export default "__VITE_ASSET__C1Qvo2DU__"